import styled from 'styled-components'
import MobileCaseStudyItem, { CaseStudySliderItemSP } from './MobileCaseStudyItem'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export type CaseStudySliderItems = CaseStudySliderItemSP[]

interface Props {
  caseStudySliderList: CaseStudySliderItems
}

const CaseStudySliderSP: React.FC<Props> = ({ caseStudySliderList }) => (
  <SliderWrapper>
    <MobileCaseStudyItem caseStudySliderList={caseStudySliderList} />
  </SliderWrapper>
)

const SliderWrapper = styled.div`
  .slick-dots {
    margin: 20px auto 0;
    position: relative;
    bottom: 0;
    text-align: left;
    @media (max-width: 1199px) {
      padding: 0 24px;
    }
    @media (min-width: 1200px) {
      padding: 0 130px;
      margin: 27px auto 0;
    }
  }

  .slick-dots li {
    width: 40px;
    height: 4px;
    background: #ccc;
    margin: 0 0 0 8px;
    @media (max-width: 719px) {
      width: 32px;
    }
  }

  .slick-dots li:first-child {
    margin: 0;
  }

  .slick-dots li.slick-active {
    background: #db0032;
  }

  .slick-dots li button {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .slick-dots li button::before {
    content: none;
  }
  .slick-slide > div {
    height: 50%;
  }
`

export default CaseStudySliderSP
